import { createQueryHook } from '../../createQueryHook'
import { CasSettings } from '../../types'

export default createQueryHook<undefined, CasSettings>({
  getKey: () => ['cas-settings'],
  getEndpoint: () => 'cas-settings'
})
